<div [formGroup]="rateioGroup">
    <!-- Centro de Custo Principal e Toggle -->
    <div class="row align-items-center mb-2">
        <div class="col-12 col-md-7">

            <app-select-pesquisavel [control]="idCentroCustoControl" [offlineList]="listaCentrosCusto"
                label="Centro de Custo Principal" idField="idCentroCusto" nameField="nome"
                [isOptional]="!isCentroCustoObrigatorio">
            </app-select-pesquisavel>

        </div>
        <div class="col-12 col-md-5 d-flex align-items-center mb-4">
            <mat-slide-toggle color="primary" [formControl]="isRateioControl">
                Rateio por Centro de Custo
            </mat-slide-toggle>
        </div>
    </div>

    <!-- Grid de Rateio: só aparece quando isRateio = true -->
    @if (isRateioAtivo) {
    <div class="row mb-3 row-align-center">
        <div class="col-12 col-md-5">
            <button type="button" mat-stroked-button class="btn-secondary" (click)="abrirSeletorRateio()">
                <mat-icon>percent</mat-icon> Selecionar configuração de rateio
            </button>
        </div>
        <div class="col-12 col-md-7 rateio-actions-inline">
            <button type="button" mat-button class="btn-link" (click)="adicionarRateio()">
                <mat-icon>add</mat-icon> Adicionar linha
            </button>
        </div>
    </div>

    <div class="rateio-grid" formArrayName="itens" (keydown.enter)="$event.preventDefault()">
        @for (ctrl of rateioItensArray.controls; track ctrl; let i = $index) {
        <div class="rateio-row" [formGroupName]="$index">

            <div class="rateio-col-centro">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Centro de Custo</mat-label>
                    <mat-select formControlName="idCentroCusto">
                        @for (cc of listaCentrosCusto; track cc.idCentroCusto) {
                        <mat-option [value]="cc.idCentroCusto">{{ cc.nome }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="rateio-col-valor">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Valor</mat-label>
                    <input matInput formControlName="valor" [currencyMask]="currencyMask"
                        (blur)="recalculoOrigemValor(i)">
                </mat-form-field>
            </div>

            <div class="rateio-col-perc">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Percentual</mat-label>
                    <input matInput formControlName="percentual" [currencyMask]="percentageMask"
                        (blur)="recalculoOrigemPercentual(i)">
                </mat-form-field>
            </div>

            <div class="rateio-col-action">
                <button type="button" mat-icon-button (click)="removerRateio(i)" matTooltip="Remover">
                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
            </div>

        </div>
        }

        @if (rateioItensArray.length === 0) {
        <div class="rateio-empty"
            [class.rateio-empty-error]="isCentroCustoObrigatorio && rateioItensArray.invalid && rateioItensArray.touched">
            Nenhuma linha de rateio configurada. Selecione uma configuração ou adicione linhas manualmente.
            @if (isCentroCustoObrigatorio && rateioItensArray.invalid && rateioItensArray.touched) {
            <span class="rateio-required-msg"> Centro de custo é obrigatório — adicione ao menos uma linha.</span>
            }
        </div>
        }

        @if (rateioItensArray.length > 0) {
        <app-percentual-progress-bar [somaPercentual]="somaPercentualRateio"></app-percentual-progress-bar>
        }
    </div>
    } <!-- fim @if isRateioAtivo -->
</div>